module.exports = __webpack_public_path__ + "static/media/Unaut.8fec40e6.png";